export const TYPE_REGROUPEMENT_TEMPO = 'REGROUPEMENT_TEMPO';
export const TYPE_REGROUPEMENT_LC = 'REGROUPEMENT_LC';
export const TYPE_EMPLACEMENT = 'EMPLACEMENT';
export const TYPE_DISPOSITIF = 'DISPOSITIF';
export const TYPE_MATERIEL = 'MATERIEL';
export const TYPE_FACE = 'FACE';
export const EXPORT_EXCEL_TOURNEE_LIGNE = 'tourneelignes';
